import { render, staticRenderFns } from "./ExpandableImage.vue?vue&type=template&id=8ea81fcc&scoped=true&"
import script from "./ExpandableImage.vue?vue&type=script&lang=js&"
export * from "./ExpandableImage.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableImage.vue?vue&type=style&index=0&id=8ea81fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea81fcc",
  null
  
)

export default component.exports